/**
 * 画手工作台
 */

import { FullChildContainer } from '@acgn/herm/src/components';

const workerRoutes: any = {
  path: 'worker',
  name: '画手工作台',
  icon: 'ift-pic',
  meta: {
    breadcrumbHidden: true
  },
  component: FullChildContainer,
  children: [
    {
      path: '',
      redirect: 'list'
    },
    {
      path: 'list',
      redirect: 'list',
      name: '画手工作台',
      component: FullChildContainer,
      children: [
        {
          path: '',
          name: 'desk-workerList',
          meta: {
            text: '项目列表',
            type: 'list',
            role: ['3002']
          },
          component: () => import('../views/comic-auth/list.vue')
        },
        {
          path: 'detail/:id',
          name: 'desk-workerDetail',
          meta: {
            text: '项目详情',
            type: 'detail',
            role: ['3004']
          },
          component: () => import('../views/worker/detail.vue')
        },
        {
          path: 'task/:id/:task_group_id/:task_id',
          name: 'desk-workerTask',
          meta: {
            text: '项目详情',
            type: 'detail',
            role: ['3003']
          },
          component: () => import('../views/worker/task.vue')
        },
        {
          path: 'statistic',
          name: 'desk-workerStatistic',
          meta: {
            text: '项目详情',
            type: 'detail',
            role: []
          },
          component: () => import('../views/worker/statistic.vue')
        },
      ]
    }
  ]
};

export {
  workerRoutes
};
